import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={43.413}
      height={43.644}
      viewBox="0 0 43.413 43.644"
      {...props}
    >
      <path
        data-name="Path 9026"
        d="M39.412 30.367a9.109 9.109 0 01-.774 1.881l1.983 2.641-3.068 3.068-2.641-1.983a9.109 9.109 0 01-1.881.774l-.47 3.278h-4.342l-.47-3.278a9.109 9.109 0 01-1.881-.774l-2.641 1.983-3.068-3.068 1.983-2.641a9.109 9.109 0 01-.774-1.881l-3.279-.47v-4.341l3.278-.47a9.109 9.109 0 01.774-1.881l-1.983-2.641 3.068-3.068 1.592 1.194 1.049.789a9.46 9.46 0 01.9-.434 9.168 9.168 0 01.977-.34l.475-3.279h4.341l.47 3.278a9.168 9.168 0 01.977.34 9.461 9.461 0 01.9.434l1.99-1.49.651-.492 3.068 3.068-1.983 2.641a9.109 9.109 0 01.774 1.881l3.278.47v4.341z"
        fill="#ff9811"
      />
      <path
        data-name="Path 9027"
        d="M34.006 23.211a5.788 5.788 0 00-2.894-1.23 5.979 5.979 0 00-.724-.043 5.788 5.788 0 000 11.577 5.961 5.961 0 001.447-.181 5.788 5.788 0 002.171-10.122z"
        fill="#ffd422"
      />
      <path
        data-name="Path 9028"
        d="M34.007 19.044a9.167 9.167 0 00-.977-.34l-.47-3.278h-1.447V9.45a5.059 5.059 0 01.724-8.726v4.573l2.171.724 2.171-.724V.724a5.059 5.059 0 01.724 8.726v8.538l-1.99 1.49a9.461 9.461 0 00-.906-.434z"
        fill="#c6c5ca"
      />
      <path
        data-name="Path 9029"
        d="M34.006 19.044v4.168a5.788 5.788 0 00-2.894-1.231v-6.555h1.447l.47 3.278a9.167 9.167 0 01.977.34z"
        fill="#ff9811"
      />
      <path
        data-name="Path 9030"
        d="M23.877 13.979H22.43a1.447 1.447 0 00-.724.2v4.146c0 .174-.007.347-.022.514a.825.825 0 00.137.072 1.438 1.438 0 00.608.137h1.447a1.4 1.4 0 00.941-.355 1.427 1.427 0 00.506-1.093v-2.174a1.451 1.451 0 00-1.446-1.447z"
        fill="#ee8700"
      />
      <path
        data-name="Path 9031"
        d="M27.213 32.56a7.189 7.189 0 00-3.545-3.032l-5.579-2.236-.723-.289a2.894 2.894 0 01-5.788 0l-6.3 2.525a7.222 7.222 0 00-4.554 6.715v6.678h27.495v-6.678a7.229 7.229 0 00-1.006-3.683z"
        fill="#3d9ae2"
      />
      <path
        data-name="Path 9032"
        d="M17.365 24.948v2.055a2.894 2.894 0 01-5.788 0v-2.055a7.2 7.2 0 005.788 0z"
        fill="#ffc477"
      />
      <path
        data-name="Path 9033"
        d="M7.236 18.32c0 .174.007.347.022.514a1.375 1.375 0 01-.745.21H5.065a1.451 1.451 0 01-1.447-1.447v-2.171a1.451 1.451 0 011.447-1.447h1.447a1.447 1.447 0 01.724.2z"
        fill="#ee8700"
      />
      <path
        data-name="Path 9034"
        d="M17.365 24.948v1.447a7.2 7.2 0 01-5.788 0v-1.447a7.2 7.2 0 005.788 0z"
        fill="#ffb655"
      />
      <path
        data-name="Path 9035"
        d="M21.706 14.174v.528h-.724a2.894 2.894 0 01-2.315-1.158l-1.3-1.737-2.432 1.948a4.324 4.324 0 01-2.706.948H7.235v-1.448a7.236 7.236 0 1114.471 0z"
        fill="#57565c"
      />
      <path
        data-name="Path 9036"
        d="M20.982 14.702a2.894 2.894 0 01-2.315-1.158l-1.302-1.736-2.43 1.946a4.324 4.324 0 01-2.706.948H7.235v3.618c0 .174.007.347.022.514a7.229 7.229 0 0012.995 3.828 6.12 6.12 0 00.673-1.078 7.1 7.1 0 00.745-2.525v-.007c.007-.072.014-.145.014-.217a6.16 6.16 0 00.022-.514v-3.619z"
        fill="#ffc477"
      />
      <path data-name="Rectangle 1184" d="M10.13 16.873h1.447v1.447H10.13z" />
      <path data-name="Rectangle 1185" d="M17.365 16.873h1.447v1.447h-1.447z" />
      <path
        data-name="Path 9037"
        d="M42.792 24.839l-2.827-.4a10.129 10.129 0 00-.475-1.158L41.2 21a.724.724 0 00-.067-.946l-3.07-3.07a.716.716 0 00-.438-.2V9.812a5.788 5.788 0 002.171-4.516A5.728 5.728 0 0036.486.07a.724.724 0 00-1.033.654v4.051l-1.447.483-1.447-.483V.72a.724.724 0 00-1.032-.651 5.728 5.728 0 00-3.309 5.224 5.788 5.788 0 002.171 4.516v4.89h-2.171a.724.724 0 00-.718.621l-.468 3.277 1.433.2.379-2.655h3.087l.379 2.655a.724.724 0 00.514.592 8.639 8.639 0 011.737.714.724.724 0 00.782-.056l2.142-1.606 2.182 2.182-1.61 2.142a.724.724 0 00-.056.782 8.638 8.638 0 01.714 1.737.724.724 0 00.592.514l2.655.379v3.087l-2.655.379a.724.724 0 00-.592.514A8.638 8.638 0 0138 31.901a.724.724 0 00.056.782l1.606 2.142-2.182 2.182-2.141-1.612a.724.724 0 00-.782-.056 8.639 8.639 0 01-1.737.714.724.724 0 00-.514.592l-.377 2.657h-2.99v-3.06a8.031 8.031 0 00-.326-2.258 6.591 6.591 0 10-4.626-5.11c-.017-.007-.034-.016-.051-.022l-5.85-2.34v-1.111a8.023 8.023 0 002.517-2.016h1.827a2.171 2.171 0 002.17-2.171v-1.58a2.171 2.171 0 001.447-2.037v-2.171a2.171 2.171 0 00-1.447-2.037v-.857a10.13 10.13 0 00-20.259 0v.857a2.171 2.171 0 00-1.447 2.037v2.171a2.171 2.171 0 002.171 2.171h1.447c.046 0 .091-.007.137-.01a7.976 7.976 0 004.2 5.644v1.112L5 28.853a7.922 7.922 0 00-5 7.39v6.677a.724.724 0 00.724.724h27.494a.724.724 0 00.724-.724v-2.17h3.618a.724.724 0 00.716-.621l.4-2.827a10.13 10.13 0 001.158-.475l2.281 1.71a.724.724 0 00.946-.067l3.07-3.07a.724.724 0 00.067-.946l-1.71-2.281a10.13 10.13 0 00.475-1.158l2.827-.4a.724.724 0 00.62-.716v-4.343a.724.724 0 00-.621-.716zm-7.959-6.214c-.034-.017-.072-.027-.106-.043V9.638h-1.444v5.738l-.007-.056a.724.724 0 00-.716-.621h-.724V9.45a.724.724 0 00-.31-.594 4.341 4.341 0 01-.413-6.8v3.24a.724.724 0 00.5.687l2.17.723a.724.724 0 00.457 0l2.171-.724a.724.724 0 00.495-.687V2.056a4.341 4.341 0 01-.413 6.8.724.724 0 00-.31.592v8.172zm-9.509 9.1a5.1 5.1 0 112.412 4.3 7.9 7.9 0 00-1.889-2.082 4.946 4.946 0 01-.522-2.217zm-2.894-5.787h-.878a7.887 7.887 0 00.742-2.181c.046 0 .09.01.137.01h.724v1.447a.724.724 0 01-.725.724zm-1.447-7.959a2.181 2.181 0 01-1.737-.868l-1.3-1.737a.724.724 0 00-.488-.284.732.732 0 00-.543.153l-2.428 1.94a3.631 3.631 0 01-2.257.8H7.959v-.724a6.512 6.512 0 0113.024 0zm3.617 3.618a.724.724 0 01-.724.724H22.43v-3.619h1.447a.724.724 0 01.724.724zM14.471 3.849a8.692 8.692 0 018.683 8.683v.724h-.724a7.959 7.959 0 00-15.918 0h-.724v-.724a8.692 8.692 0 018.683-8.683zM5.065 18.32a.724.724 0 01-.724-.724v-2.17a.724.724 0 01.724-.724h1.447v3.618zm2.894 0v-2.894h4.269a5.082 5.082 0 003.163-1.106l1.846-1.477.852 1.14a3.636 3.636 0 002.894 1.447v2.89a6.474 6.474 0 01-1.1 3.618h-5.412v1.447h4.084A6.505 6.505 0 017.959 18.32zm6.512 7.959a7.934 7.934 0 002.171-.308v1.032a2.171 2.171 0 11-4.341 0v-1.032a7.935 7.935 0 002.17.308zm13.024 15.918h-4.342v-7.959h-1.447v7.959H7.235v-7.959H5.788v7.959H1.447v-5.954a6.482 6.482 0 014.094-6.047l5.472-2.189a3.595 3.595 0 006.916 0l5.471 2.189a6.482 6.482 0 014.094 6.047z"
      />
      <path data-name="Rectangle 1186" d="M29.665 17.597h1.447v1.447h-1.447z" />
      <path data-name="Rectangle 1187" d="M29.665 36.409h1.447v1.447h-1.447z" />
      <path
        data-name="Rectangle 1188"
        d="M36.016 34.377l1.023-1.023 1.023 1.023L37.04 35.4z"
      />
      <path data-name="Rectangle 1189" d="M39.071 27.003h1.447v1.447h-1.447z" />
      <path
        data-name="Rectangle 1190"
        d="M36.017 21.075l1.023-1.023 1.023 1.023-1.023 1.023z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
